<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">Reserve Seats</div>
      </div>
    </div>

    <b-modal
      title="Reservation Id"
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      ref="reservation_id_popup"
      id="reservation_id_popup"
      class="seat_select_modal"
    >
      <div class="text-center pt-4">
        <h5 class="font-weight-bold text-blue mb-3">
          Please copy this Reservation Id for Unpaid Booking.
        </h5>
        <div class="d-flex justify-content-center">
          <div class="font-weight-bold fs-22">{{ reservation_id }}</div>
        </div>
      </div>
    </b-modal>

    <div class="white-wrapper">
      <div class="row">
        <!-- Cinema -->
        <div class="col-lg-4 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              style="font-weight: bold"
              >cinema</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.cinema.length == 0">{{
              msgcinema
            }}</span>
          </p>
        </div>
        <!-- Cinema -->

        <!-- show Date -->
        <div class="col-lg-4 col-xl-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="dateenable"
                  :disabledDates="disabledDates"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  id="showdate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="typeof showdate === 'object' ? 'active' : ''"
                  >{{ $tc("show", 1) }} {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- Show Date -->

        <!-- Movie -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container dropdown-text-truncate">
            <label
              :class="selectedMovie ? 'shift-up' : ''"
              style="font-weight: bold;"
              >Movie</label
            >
            <multiselect
              :options="MoviesList"
              v-model="selectedMovie"
              :searchable="true"
              :placeholder="'Movie'"
              label="movie_name"
              track-by="md_id"
              @select="onSelectMovie(null, $event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
            <!-- <b-dropdown
              :disabled="movieenable"
              :text="selected.movie_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Movie"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchMovie()"
                  v-on:keydown="onSearchMovie()"
                  v-on:search="onSearchMovie()"
                  v-model="searchMovie"
                />
              </div>
              <b-dropdown-item
                v-for="(movie, movieIndex) in MoviesList"
                @click="onSelectMovie($event, movie)"
                :key="movieIndex"
                >{{ movie.movie_name || movie.movie_title }}</b-dropdown-item
              >
            </b-dropdown> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.movie_name.length == 0"
              class="error_message"
              >{{ msgmovie }}</span
            >
          </p>
        </div>
        <!-- Movie -->

        <!-- Screen -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container dropdown-text-truncate">
            <label
              :class="selectedScreen ? 'shift-up' : ''"
              style="font-weight: bold"
              >screen</label
            >
            <multiselect
              :options="ScreenList"
              v-model="selectedScreen"
              :searchable="true"
              :placeholder="'Screen'"
              label="screen_name"
              track-by="screen_id"
              @select="onSelectScreen(null, $event, null)"
              @input="onchangeStartDate"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
            <!-- <b-dropdown
              :disabled="ScreenList.length == 0"
              :text="selected.screen_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in ScreenList"
                @click="onSelectScreen($event, Screen, ScreenIndex)"
                :key="ScreenIndex"
                >{{ Screen.screen_name }}</b-dropdown-item
              >
            </b-dropdown> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.screen_name.length == 0"
              class="error_message"
              >{{ msgscreen }}</span
            >
          </p>
        </div>
        <!-- Screen -->

        <!-- Show Time -->
        <div class="col-lg-4 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.show_time && selected.show_time.length > 0
                  ? 'shift-up'
                  : ''
              "
              style="font-weight: bold;"
              >showtime</label
            >
            <b-dropdown
              :disabled="ShowTime.length == 0"
              :text="selected.show_time"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(show, showIndex) in ShowTime"
                :key="showIndex"
                @click="onSelectShow($event, show)"
                >{{ show.ss_start_show_time }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.show_time.length == 0"
              class="error_message"
              >{{ msgshowtime }}</span
            >
          </p>
        </div>
        <!-- Show Time -->

        <div class="col-lg-4 col-xl-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="sstr_remark"
                name="sstr_remark"
                id="sstr_remark"
              />
              <label>{{ $t("Remarks") }}</label>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-lg-3">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue w-100"
          >
            Seats Details
          </button>
        </div>

        <div v-if="flag" class="col-12">
          <hr class="mt-0" />
        </div>

        <div v-if="flag" class="col-12 text-center">
          <div class="d-flex w-100 justify-content-between mb-4">
            <div class="d-flex">
              <div
                v-for="(seatType, seatTypeIndex) in seatTypes"
                :key="seatTypeIndex"
                :class="seatType.value == 1 ? 'mx-1 px-xl-3' : 'mx-1 mx-xl-3'"
              >
                <div
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  v-on:click="selectSeatType(seatType)"
                  class="pos-seat bg-blue cursor-pointer"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >

                <div
                  v-if="
                    seatType.value != 5 &&
                      seatType.value != 1 &&
                      seatType.value != 12 &&
                      seatType.value != 8
                  "
                  class="pos-seat disabled cinema-seat bg-blue"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    seatType.value != 5 &&
                      seatType.value != 1 &&
                      seatType.value != 12 &&
                      seatType.value != 8
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >
                <div v-if="seatType.value == 8" class="mx-1">
                  <div
                    class="pos-seat my-0 taken seat-fixed-width mx-auto"
                  ></div>
                  <small>{{ $t("taken") }}</small>
                </div>
              </div>
            </div>
          </div>
          <h5>All eyes this way.</h5>

          <div class="col-12">
            <div
              class="pos-seatlayout mb-3"
              style="height: 100%; max-height: 70vh"
            >
              <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
                <!-- SLIVER CLASS LABEL -->
                <tr>
                  <td colspan="22">
                    <div class="pos-seat-class">{{ seat.seatType }}</div>
                  </td>
                </tr>

                <tr
                  v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
                  :key="seatRowIndex"
                >
                  <td
                    v-for="(singleSeat, singleSeatIndex) in seatRow"
                    :key="'index' + singleSeatIndex"
                  >
                    <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <div v-else class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <!-- {{singleSeat.seat_reserve_type_id}} -->
                    <div
                      v-on:click="
                        onClickSeat(
                          singleSeat,
                          seatRowIndex,
                          singleSeatIndex,
                          null,
                          null,
                          $event,
                          seatIndex
                        )
                      "
                      class="pos-seat cursor-pointer"
                      :style="{
                        borderColor:
                          singleSeat.selectStatus == true
                            ? '#01d04a !important'
                            : singleSeat.seat_reserve_type_id == 8
                            ? ''
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                        backgroundColor:
                          singleSeat.selectStatus == true
                            ? ''
                            : singleSeat.seat_reserve_type_id == 8
                            ? ''
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                      }"
                      :class="
                        singleSeat.isVipReserved
                          ? 'reserved-seat taken pointer-events'
                          : singleSeat.srt_id == 2
                          ? 'normal-seat pointer-events'
                          : ''
                      "
                    >
                      <img
                        :src="getSeatIconURL(singleSeat)"
                        height="28"
                        width="28"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <button
            :disabled="btenable"
            @click.prevent.stop="OnSave()"
            class="btn-blue"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <ManagerAuthLogin
      :moduleName="'dash_seatLayout'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_dashSeatLayout'"
    />
  </div>
</template>

<script>
  import scheduleService from "@/services/scheduleService";
  import CinemasService from "@/services/CinemasService";
  import MasterService from "@/services/MasterService";
  import PosService from "@/services/PosService";
  import ExhibitorService from "@/services/ExhibitorService";
  import _ from "lodash";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import moment from "moment";

  export default {
    components: { ManagerAuthLogin },
    data() {
      return {
        noAuth: false,
        clickSeatTempData: {
          seat: null,
          rowIndex: null,
          seatIndex: null,
          originalIndex: null,
          backward: null,
          e: null,
          type: null,
        },
        selectedScreen: null,
        selectedMovie: null,
        MoviesListCopy: [],
        searchMovie: "",
        CinemasListCopy: [],
        searchCinema: "",
        btenable: false,
        isRoleID: true,
        submitted: false,
        dateenable: true,
        movieenable: true,
        msgcinema: "",
        msgscreen: "",
        msgmovie: "",
        msgshowtime: "",
        selected: {
          cinema: "",
          screen_name: "",
          movie_name: "",
          show_time: "",
        },
        sstr_remark: "",
        showdate: "",
        cineid: "",
        screenid: "",
        movieid: "",
        showid: "",
        turnOffMultiSeatSelection: "N",

        flag: false,
        disabledDates: {
          to: new Date(Date.now() - 8640000),
        },
        reservation_id: null,
        SetAllSeats: [],
        Seats: [],
        CinemasList: [],
        MoviesList: [],
        ScreenList: [],
        selectedMoviesInScreens: [],
        ShowTime: [],
        activeSeatTypes: [],
        seatTypeSelected: {
          seatName: "regularSeat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
        },
        screenSeatTypeSelected: {},
        seatTypeSelectionMode: "seatType",
        seatTypes: [
          {
            seatName: "Regular Seat",
            size: 1,
            value: 1,
            imageClass: "regular-seat",
            imageURL: "",
          },
          {
            seatName: "No Seat",
            size: 1,
            value: 2,
            imageClass: "no-seat",
            imageURL: "",
          },
          {
            seatName: "Wheel Chair",
            size: 1,
            value: 3,
            imageClass: "wheelchair",
            imageURL: "",
          },
          {
            seatName: "VIP Seat",
            size: 1,
            value: 5,
            imageClass: "vip-seat",
            imageURL: "",
          },
          {
            seatName: "Only POS",
            size: 1,
            value: 9,
            imageClass: "pointofsale",
            imageURL: "",
          },
          {
            seatName: "Sofa",
            size: 1,
            value: 10,
            imageClass: "sofa-seat",
            imageURL: "",
          },
          {
            seatName: "Recliner",
            size: 1,
            value: 11,
            imageClass: "recliner",
            imageURL: "",
          },
          {
            seatName: "Broken Seat",
            size: 1,
            value: 13,
            imageClass: "broken-seat",
            imageURL: "",
          },
        ],
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
        this.getAllActiveCinemas(obj);
      } else {
        this.getAllActiveCinemas(obj);
      }
      this.getAllActiveMovies();
      this.SetAllSeats = [];
      this.getSeatTypes();
    },
    computed: {
      seatType() {
        return this.$store.getters.SEAT_LAYOUT_DATA;
      },
      scheduleShowId() {
        return this.$store.getters.SCHEDULE_SHOW_ID;
      },
      MANAGER_AUTH_FOR_CHANGES() {
        return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
      },
    },
    methods: {
      moment,
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "dash_seatLayout") {
            this.noAuth = true;
            const {
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type,
            } = this.clickSeatTempData;
            this.onClickSeat(
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type
            );
            this.$bvModal.hide("authManager_dashSeatLayout");
          }
        }
      },
      checkAlreadyBlocked(seat) {
        if (seat.seat_reserve_type_id == 8 && !seat.selectStatus) {
          return false;
        } else if (
          seat.seat_reserve_type_id == 8 &&
          seat.selectStatus == true
        ) {
          return true;
        } else {
          return true;
        }
      },
      getSeatTypes: function(screen) {
        let payload = {
          tableName: "ms_seat_reserve_types",
          srt_is_active: "Y",
        };
        this.seatTypes = [];
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.activeSeatTypes = data.Records;
              this.activeSeatTypes.map((x) => {
                let obj = {
                  seatName: x.srt_name,
                  size: x.srt_seat_capacity,
                  value: x.srt_id,
                  imageClass: "regular-seat",
                  imageURL: this._GetImagePath(x.srt_dash_image_url),
                };
                if (x.srt_id == 1) {
                  this.seatTypeSelected = obj;
                }
                this.seatTypes.push(obj);
              });
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error :", error);
          });
      },
      onSearchMovie: function() {
        if (this.searchMovie && this.searchMovie.length > 0) {
          this.MoviesList = this.MoviesListCopy.filter((x) => {
            if (
              x.movie_title
                .toLowerCase()
                .includes(this.searchMovie.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.MoviesList = this.MoviesListCopy;
        }
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.CinemasList = this.CinemasListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.CinemasList = this.CinemasListCopy;
        }
      },
      getSeatIconURL(singleSeat) {
        let iconPath = ``;
        if (singleSeat.selectStatus) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
        } else if (
          singleSeat.seat_reserve_type_id == 12 ||
          singleSeat.seat_reserve_type_id == 8
        ) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
        } else {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
        }
        return iconPath;
      },
      ResetForm: function() {
        this.btenable = false;
        this.submitted = false;
        this.selected.cinema = "";
        this.selected.screen_name = "";
        this.selected.movie_name = "";
        this.showdate = "";
        this.selected.show_time = "";
        this.flag = false;
        this.SetAllSeats = [];
        // this.seatType = "";
      },
      clearSelectedDate: function() {
        this.showdate = "";
      },
      onCopyId(id) {
        this.$copyText(id).then((e) => {
          if (e.action === "copy") {
            this.$toasted.show("Reservation Id Copied");
          } else {
            this.$toasted.show("Cannot Copy Reservation Id");
          }
        });
      },
      onchangeStartDate: _.debounce(function(query) {
        this.getshowtimebyMovie();
      }, 1.5 * 1000),
      getshowtimebyMovie: function() {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cineid,
          screen: this.screenid,
          movie: this.movieid,
          date: moment(this.showdate).format("YYYY-MM-DD HH:mm"),
        };
        console.log("payload :", payload);

        scheduleService
          .GetShowTimebyMovie(payload)
          .then((response) => {
            console.log("response :", response);
            const { data } = response;

            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                this.ShowTime = data.Records;
              } else {
                this.showdate = "";

                this.$toasted.show(
                  `No Shows Found for ${this.selected.movie_name} in ${this.selected.screen_name}`
                );
              }
            } else {
              this.showdate = "";

              this.$toasted.show(
                `No Shows Found for ${this.selected.movie_name} in ${this.selected.screen_name}`
              );
            }
          })
          .finally(() => {
            loader.hide();
          });
      },
      getAllActiveCinemas: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
              this.CinemasListCopy = data.Records;
              this.CinemasList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selected.cinema = x.cine_name;
                  let cinema = {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  };
                  this.onSelectCinema(event, cinema);
                }
              });
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveCinemas :", error);
          });
      },
      onSelectCinema: function(event, cinema) {
        this.selected.cinema = cinema.cine_name;
        this.cineid = cinema.cine_id;
        this.dateenable = false;
        this.getAllActiveScreens(cinema.cine_id);
        this.searchCinema = "";
        this.onSearchCinema(null);

        this.selected.screen_name = "";
        this.screenid = "";
        this.movieenable = true;
        // this.selected.movie_name = "";
        this.movieid = "";
        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.submitted = false;
        this.SetAllSeats = [];
      },
      getAllActiveScreens: function(cinema_id) {
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status && data.Records.length > 0) {
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenList.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      onSelectScreen: function(event, screen, screenindex) {
        this.selected.screen_name = screen.screen_name;
        this.screenid = screen.screen_id;
        this.movieenable = false;

        // this.selected.movie_name = "";
        // this.movieid = "";
        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.SetAllSeats = [];
        this.submitted = false;
      },
      getAllActiveMovies: function() {
        scheduleService
          .GetMovies()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult;
              this.MoviesListCopy = data.MovieListResult;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAllActiveMovies :", error);
          });
      },
      onSelectMovie: function(event, movie) {
        this.selected.movie_name = movie.movie_name || movie.movie_title;
        this.movieid = movie.md_id;
        this.dateenable = false;
        this.searchMovie = "";

        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.SetAllSeats = [];
        this.submitted = false;
        this.onSearchMovie();
      },
      onSelectShow: function(event, show) {
        this.selected.show_time = show.ss_start_show_time;
        this.showid = show.ss_id;
        this.turnOffMultiSeatSelection = show.turnOffMultiSeatSelection;
        // this.enablefetch = false;
      },
      onFinalSubmit: function() {
        this.submitted = true;
        this.SetAllSeats = [];
        if (this.selected.cinema.length == 0) {
          this.msgcinema = "Please Select Cinema.";
          return;
        } else if (this.selected.screen_name.length == 0) {
          this.msgscreen = "Please Select Screen.";
          return;
        } else if (this.selected.movie_name.length == 0) {
          this.msgmovie = "Please Select Movie.";
          return;
        } else if (this.selected.show_time.length == 0) {
          this.msgshowtime = "Please select Show Time";
          return;
        } else {
          this.$validator.validate().then(async (valid) => {
            if (valid) {
              let loader = this.$loading.show();
              this.btenable = true;
              let data = {};

              let seats = await PosService.getReservesSeatLayout({
                screen_id: this.screenid,
                ss_id: this.showid,
                md_id: this.movieid,
              });
              data.seats = seats.data;

              let seatType = await PosService.getSeatType({
                screen_id: this.screenid,
                ss_id: this.showid,
                md_id: this.movieid,
              });
              data.seatType = seatType.data;

              if (seats && seats.status) {
                this.btenable = false;
                this.flag = true;
                this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
                loader.hide();
              } else {
                this.btenable = false;
                vue.toasted.show(data.message || "Please try later");
                loader.hide();
              }
            }
          });
        }
      },

      selectSeatType: function(seatType) {
        console.log(seatType);
        this.seatTypeSelected = seatType;
        this.seatTypeSelectionMode = "seatType";
      },
      onClickSeat(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
        let self = this;
        if ([2, 12, 13].includes(seat.seat_reserve_type_id)) {
          this.$toasted.show("Not Available");
          return false;
        } else if (
          this.MANAGER_AUTH_FOR_CHANGES == "Y" &&
          !this.noAuth &&
          [4].includes(seat.seat_reserve_type_id)
        ) {
          let tempObj = {
            seat,
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            e,
            type,
          };
          Object.keys(this.clickSeatTempData).map((key) => {
            this.clickSeatTempData[key] = tempObj[key];
          });
          this.$bvModal.show("authManager_dashSeatLayout");
        } else if (
          seat.srt_multi_select == "Y" &&
          this.turnOffMultiSeatSelection != "Y" &&
          seat.sl_group_id
        ) {
          let groupSeatsIndexes = [];
          groupSeatsIndexes = this.seatType[type].seatsFinal[rowIndex].reduce(
            function(a, e, i) {
              if (
                e.sl_group_id == seat.sl_group_id &&
                ![2, 12, 13].includes(e.seat_reserve_type_id) &&
                self.checkAlreadyBlocked(e)
              )
                a.push(i);
              return Array.from(new Set(a));
            },
            []
          );

          console.log("groupSeatsIndexes", groupSeatsIndexes);

          if (groupSeatsIndexes && groupSeatsIndexes.length > 0) {
            for (let i = 0; i < groupSeatsIndexes.length; i++) {
              this.handlerSeatSelected(
                this.seatType[type].seatsFinal[rowIndex][groupSeatsIndexes[i]],
                rowIndex,
                groupSeatsIndexes[i],
                originalIndex,
                backward,
                e,
                type
              );
            }
          }
        } else {
          this.handlerSeatSelected(
            seat,
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            e,
            type
          );
        }
      },
      handlerSeatSelected: function(
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type
      ) {
        console.log("seat", seat);
        // this.SetAllSeats = [];
        seat.seatIndex = seatIndex;
        seat.rowIndex = rowIndex;

        let selectedIndex = this.SetAllSeats.findIndex(
          (x) => String(x.seat.sl_id) === String(seat.sl_id)
        );

        if (selectedIndex !== -1) {
          this.SetAllSeats.splice(selectedIndex, 1);
          this.$store.dispatch("SEAT_SELECTION_FALSE", {
            seat: seat,
            seattype: this.seatTypeSelected,
          });

          this.$forceUpdate();
        } else {
          this.SetAllSeats.push({
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            type,
            seat: seat,
          });
          this.$store.dispatch("SEAT_SELECTION_TRUE", {
            seat: seat,
            seattype: this.seatTypeSelected,
          });
        }
      },
      simpleStringify(object) {
        var simpleObject = {};
        for (var prop in object) {
          if (!object.hasOwnProperty(prop)) {
            continue;
          }
          if (typeof object[prop] == "object") {
            continue;
          }
          if (typeof object[prop] == "function") {
            continue;
          }
          simpleObject[prop] = object[prop];
        }
        return simpleObject; // returns cleaned up JSON
      },

      OnSave: async function() {
        console.log(this.SetAllSeats, "dsfsd");
        if (this.SetAllSeats.length > 0) {
          let arraySeats = [];
          this.SetAllSeats.map((x) => {
            let obj = this.simpleStringify(x.seat);
            x["seat"] = obj;
            arraySeats.push(x);
          });
          console.log(arraySeats);
          this.reservation_id = null;
          let payload = {
            cine_id: this.cineid,
            screen_id: this.screenid,
            schedule_show_id: this.showid,
            movie_id: this.movieid,
            allSeats: arraySeats,
            remarks: this.sstr_remark,
          };

          console.log(payload, "sdfds");
          ExhibitorService.ReserveSeat(payload).then(async (response) => {
            console.log("response", response);
            const { data } = response;
            if (data && data.status) {
              // this.$toasted.show(data.message);
              this.reservation_id = data.reservation_id || null;
              this.$refs["reservation_id_popup"].show();
              await this.ResetForm();
              this.$router.push({
                path: "/cinema-manager/reserve-seats-list",
              });
            } else {
              this.$toasted.show(data.message);
            }
          });
        } else {
          this.$toasted.show("Please select at least one reserve seat.");
        }
      },
    },
  };
</script>

<style>
  .grey {
    background-color: lightgray;
  }
  .reserve-seat-layout {
    margin: 0 auto;
  }
  .normal-seat {
    display: none !important;
  }

  .reserve-seat-layout td {
    padding: 5px;
  }
  .reserve-seat-layout .cinema-seat {
    background-color: #fff;
  }
  .fs-22 {
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ReserveSeatComponent/reserveSeats.vue